import PodcastCard from "./PodcastCard";

export default PodcastCard;
